<script>
/* globals axios route */

import UsersSwitch from '../users/UsersSwitch.vue';
import VueLogout from '../auth/Logout.vue';
import ErrorHandler from '../../core/ErrorHandler';

export default {
  /* globals Pistor */
  props: [],

  components: { UsersSwitch, VueLogout },

  data() {
    return {
      fetchingCarts: false,
      fetchingNotifications: false,
      unreadNotificationsCount: 0,
      notExiredCartsCount: 0,
      environmentDev: Pistor && Pistor.name === 'dev',
    };
  },

  created() {
    this.getUnreadNotificationsCount();
    Event.listen('notificationCreated', () =>
      this.getUnreadNotificationsCount(),
    );
    Event.listen('notificationUpdated', () =>
      this.getUnreadNotificationsCount(),
    );

    this.getNotExpiredCartsCount();
    Event.listen('cartCreated', () => this.getNotExpiredCartsCount());
    Event.listen('cartDeleted', () => this.getNotExpiredCartsCount());
    Event.listen('orderCreated', () => this.getNotExpiredCartsCount());
  },

  methods: {
    getNotExpiredCartsCount() {
      if (this.fetchingCarts) {
        return;
      }
      this.fetchingCarts = true;
      axios
        .get(`${route('api.carts.index')}?status=not-expired`)
        .then(({ data }) => {
          this.fetchingCarts = false;
          this.notExiredCartsCount = data.meta.total;
        })
        .catch((error) => {
          this.fetchingCarts = false;
          new ErrorHandler(error).dispatch();
        });
    },

    getUnreadNotificationsCount() {
      if (this.fetchingNotifications) {
        return;
      }
      this.fetchingNotifications = true;
      axios
        .get(`${route('api.notifications.index')}?read=0`)
        .then(({ data }) => {
          this.fetchingNotifications = false;
          this.unreadNotificationsCount = data.meta.total;
        })
        .catch((error) => {
          this.fetchingNotifications = false;
          new ErrorHandler(error).dispatch();
        });
    },

    goTo(route) {
      window.location.href = window.route(route);
    },
  },
};
</script>